const PANEL = "https://kaisosystem.com/affiliate";
const SUPPORT_WA = "https://wa.me/34611564839";
const SUPPORT_EMAIL = "mailto:grupokaiso@yahoo.com";

export function CommissionSection({ t }) {
  return (
    <section style={{ marginBottom: 64 }}>
      <h2 style={{ fontSize: "clamp(18px,4vw,26px)", fontWeight: 800, color: "#fff", margin: "0 0 6px" }}>{t.com_title}</h2>
      <p style={{ color: "#777", fontSize: 14, marginBottom: 28 }}>{t.com_sub}</p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(190px,1fr))", gap: 14, marginBottom: 20 }}>
        {t.tiers.map((tier, i) => (
          <div key={tier.l} style={{
            background: "#111", border: `1px solid ${i === 1 ? "#22c55e44" : "#22c55e22"}`,
            borderRadius: 16, padding: "28px 20px", textAlign: "center",
            boxShadow: i === 1 ? "0 0 24px #22c55e11" : "none",
          }}>
            <div style={{ color: "#777", fontSize: 13, marginBottom: 8 }}>{tier.l}</div>
            <div style={{ color: "#4ade80", fontSize: 36, fontWeight: 900, lineHeight: 1.1 }}>{tier.mo}</div>
            <div style={{ color: "#555", fontSize: 12, marginTop: 4 }}>/mês</div>
            <div style={{ marginTop: 12, background: "#1a2e1a", borderRadius: 6, padding: "5px 12px", fontSize: 11, color: "#4ade80", fontWeight: 700 }}>
              {tier.s}
            </div>
          </div>
        ))}
      </div>

      <div style={{ background: "linear-gradient(135deg,#0f1f0f,#111)", border: "1px solid #22c55e33", borderRadius: 12, padding: "16px 20px", fontSize: 14, color: "#bbb", lineHeight: 1.7 }}>
        {t.com_note}
      </div>
    </section>
  );
}

export function CTASupportSection({ t }) {
  return (
    <>
      <section style={{ textAlign: "center", background: "linear-gradient(135deg,#0f1f0f,#111)", border: "1px solid #22c55e44", borderRadius: 20, padding: "56px 24px", marginBottom: 24 }}>
        <div style={{ fontSize: 44, marginBottom: 14 }}>🚀</div>
        <h2 style={{ fontWeight: 900, fontSize: "clamp(20px,4vw,28px)", color: "#fff", margin: "0 0 12px" }}>{t.cta_title}</h2>
        <p style={{ color: "#888", fontSize: 15, marginBottom: 32, maxWidth: 480, margin: "0 auto 32px" }}>{t.cta_sub}</p>
        <a
          href={PANEL}
          style={{
            display: "inline-block",
            background: "linear-gradient(135deg,#22c55e,#16a34a)",
            color: "#000", padding: "16px 40px", borderRadius: 12,
            fontWeight: 800, fontSize: 16, textDecoration: "none",
            boxShadow: "0 4px 28px #22c55e55",
          }}
        >
          {t.cta_btn}
        </a>
      </section>

      <section style={{ marginBottom: 40 }}>
        <div style={{
          background: "#111", border: "1px solid #1e1e1e", borderRadius: 16,
          padding: "24px 28px", display: "flex", flexWrap: "wrap", gap: 20, alignItems: "center",
        }}>
          <div style={{ flex: 1, minWidth: 180 }}>
            <div style={{ fontWeight: 800, color: "#fff", fontSize: 16, marginBottom: 4 }}>{t.support_title}</div>
            <div style={{ color: "#777", fontSize: 14 }}>{t.support_body}</div>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
            <a href={SUPPORT_WA} target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", gap: 8, background: "#1a2e1a", border: "1px solid #22c55e33", borderRadius: 10, padding: "10px 16px", textDecoration: "none" }}>
              <span style={{ fontSize: 20 }}>💬</span>
              <div>
                <div style={{ color: "#4ade80", fontSize: 11, fontWeight: 700 }}>{t.support_wa_label}</div>
                <div style={{ color: "#fff", fontSize: 13, fontWeight: 600 }}>+34 611 564 839</div>
              </div>
            </a>
            <a href={SUPPORT_EMAIL} style={{ display: "flex", alignItems: "center", gap: 8, background: "#1a1a2e", border: "1px solid #3b82f633", borderRadius: 10, padding: "10px 16px", textDecoration: "none" }}>
              <span style={{ fontSize: 20 }}>✉️</span>
              <div>
                <div style={{ color: "#60a5fa", fontSize: 11, fontWeight: 700 }}>{t.support_email_label}</div>
                <div style={{ color: "#fff", fontSize: 13, fontWeight: 600 }}>grupokaiso@yahoo.com</div>
              </div>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
